import React, { FC } from "react";
import { TrainingListItem } from "src/shared/models";
import { Table } from "src/shared/components";
import { SortTable } from "src/shared/interfaces";

import { trainingTableProperties } from "./tableHelpers";

export interface TrainingForTeamMemberTableProps extends SortTable {
  trainings: TrainingListItem[];
  onLoadNextPage: () => void;
  onClickTraining: (training: TrainingListItem) => void;
}

const TrainingForTeamMemberTable: FC<TrainingForTeamMemberTableProps> = (props) => {
  const { trainings, onLoadNextPage, onClickTraining, sortBy, sortOrder, onChangeSorting } = props;

  return (
    <div className="trainings-table">
      <Table<TrainingListItem>
        onRowClick={onClickTraining}
        onFinishScroll={onLoadNextPage}
        items={trainings}
        properties={trainingTableProperties}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onChangeSorting={onChangeSorting}
      />
    </div>
  );
};

export default TrainingForTeamMemberTable;
